if(!customElements.get('featured-products')) {
  customElements.define(
    'featured-products',
    class FeaturedProducts extends HTMLElement {
      #sliderEl = undefined;
      #sliderInstance = undefined;
      #sliderPrevEl = undefined;
      #sliderNextEl = undefined;
      #sliderPaginationEl = undefined;

      connectedCallback() {
        this.#sliderEl = this.querySelector('[data-slider]');
        this.#sliderPrevEl = this.querySelector('[data-slider-prev]');
        this.#sliderNextEl = this.querySelector('[data-slider-next]');
        this.#sliderPaginationEl = this.querySelector('[data-slider-pagination]');
        this.mount();
      }

      mount() {
        if(!this.#sliderEl) {
          this.remove();
          return console.error('[Featured Products] No slider element was found.');
        }
        
        this.#sliderInstance = new Swiper(this.#sliderEl, {
          slidesPerView: 1,
          spaceBetween: 12,
          breakpoints: {
            640: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 4,
            }
          },
          navigation: {
            prevEl: this.#sliderPrevEl,
            nextEl: this.#sliderNextEl,
          },
          pagination: {
            el: this.#sliderPaginationEl,
            type: "bullets",
            clickable: true
          }
        });
      }

      get slider() {
        return this.#sliderInstance;
      }
    }
  )
}